import React, { useState, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { API } from '../../../../javascripts/api'
import CSSModules from 'react-css-modules'
import ClientMonthlyWorkReportsTable from 'spa/client/components/ClientMonthlyWorkReportsTable'
import ClientLayout from 'spa/client/layouts/ClientLayout'
import styles from './style.module.scss'
import { MonthlyWorkReport } from 'javascripts/api/generated'
import { useSearchQuery } from 'spa/hooks/useSearchQuery'
import Pagination from 'spa/client/components/Pagination'

const ClientMonthlyWorkReports: React.FC = CSSModules<React.FC>(() => {
  const [monthlyWorkReports, setMonthlyWorkReports] = useState<MonthlyWorkReport[]>([])
  const location = useLocation()
  const navigate = useNavigate()
  const query = useSearchQuery()

  const getPageQuery = () => {
    const page = query.get('page')
    return page ? Number(page) : 1
  }

  const initialPage = getPageQuery()
  const [currentPage, setCurrentPage] = useState(initialPage)
  const [totalPages, setTotalPages] = useState(initialPage)

  const fetchReports = async (page: number) => {
    try {
      const response = await API.getClientMonthlyWorkReports(page)
      setMonthlyWorkReports(response.data)
      const parseHeader = (headerValue: any): number => {
        return typeof headerValue === 'string' ? parseInt(headerValue, 10) : 0
      }

      setTotalPages(parseHeader(response.headers['x-total-pages']))
    } catch (error) {
      if (API.isAxiosError(error)) {
        if (API.isUnauthorizedError(error.response)) {
          navigate('/client_auth/login', {
            state: {
              flash: { error: 'ログインしてください。' },
              backTo: location.pathname,
            }
          })
        }
      }
    }
  }

  useEffect(() => {
    navigate(currentPage === 1 ? '' : `?page=${currentPage}`)
  }, [currentPage])

  useEffect(() => {
    const page = getPageQuery()
    setCurrentPage(page)

    const fetchData = async () => {
      await fetchReports(page)
    }

    fetchData().catch(console.error)
  }, [location.search])

  const handlePageChange = (data: { selected: number }) => {
    const page = data.selected + 1
    setCurrentPage(page)
  }

  return (
    <ClientLayout>
      <div styleName='wrapper'>
        <div styleName='breadcrumbs'>
          <h1 styleName='item-title' >作業報告書一覧</h1>
        </div>
        <ClientMonthlyWorkReportsTable monthlyWorkReports={ monthlyWorkReports }/>
        <Pagination initialPage={currentPage} totalPages={totalPages} handlePageChange={handlePageChange} />
      </div>
    </ClientLayout>
  )
}, styles)

export default ClientMonthlyWorkReports
